import styles from "./AppFooter.module.css"
import pmlogo from "../../images/pmlogo.png"
import offer from "../../utils/offer.pdf"
import phoneIcon from "../../images/phoneIcon.png"
import geoIcon from "../../images/geoIcon.png"

export default function AppFooter(){
  return(
    <footer className={styles.appFooter}>
      <div>
        <a className={styles.logo} href="/">
          <img className={styles.logo__img} src={pmlogo} alt="" />
          <p className={styles.logo__text}>питер мобиль</p>
        </a>
        <div className={styles.additionalBlock}>
          <a href={offer} className={styles.additionalBlock__text} target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a>
          <p className={styles.additionalBlock__text}>© Copyright Питер мобиль, 2010-2024</p>
        </div>
      </div>
      <div className={styles.contacts}>
        <p className={styles.contact}><img className={styles.contact__icon_phone} src={phoneIcon} alt="" /><span className={styles.contact__number}>8-993-983-89-98</span></p>
        <div className={styles.contact__container}><img className={styles.contact__icon_geo} src={geoIcon} alt="" /><p className={styles.contact}>Санкт-Петербург,<br /> Лиговский проспект 160Б</p></div> 
      </div>
      <div className={styles.adBlock}>
        <p className={styles.adBlock__text}>ИП Горынцев Игорь Сергеевич<br />ИНН: 290400676357</p>
      </div>
    </footer>
  )
}